export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20colorful%20fashion%20accessories%20and%20clothing%20items%20arranged%20in%20a%20creative%20circular%20composition%20on%20a%20rich%20textured%20dark%20wood%20table%2C%20dramatic%20top-down%20lighting%20with%20warm%20golden%20highlights%2C%20editorial%20luxury%20product%20photography%20with%20deep%20shadows%20and%20vibrant%20color%20pops&width=1800&height=1200&seq=hero-v2-kakobuy-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-6xl mx-auto text-center">
        <div className="flex flex-col items-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs md:text-sm font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            Updated Daily &middot; June 2026
          </span>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl drop-shadow-lg">
            Best Kakobuy Spreadsheet 2026
            <br />
            <span className="text-accent-300">Updated Daily Product Lists</span>
          </h1>

          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/90 max-w-2xl leading-relaxed drop-shadow-md">
            Discover the latest Kakobuy Spreadsheet with trusted products, buying guides, shipping tips, and curated categories updated every day. Your go-to resource for smarter, faster shopping.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
            <a
              href="#categories"
              className="px-7 py-3 bg-accent-500 text-background-50 font-semibold rounded-md hover:bg-accent-600 transition-all duration-200 active:scale-[0.98] whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
            >
              Explore Spreadsheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 border-2 border-background-50/80 text-background-50 font-semibold rounded-md hover:bg-background-50/10 transition-all duration-200 active:scale-[0.98] whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 bg-background-50 text-foreground-900 font-semibold rounded-md hover:bg-background-100 transition-all duration-200 active:scale-[0.98] whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
            {["Daily Updated", "Beginner Friendly", "Buying Guides", "Shipping Tips", "Safe Shopping"].map((tag) => (
              <span key={tag} className="flex items-center gap-1.5 text-xs md:text-sm text-background-50/85 drop-shadow-sm">
                <i className="ri-check-line text-accent-400"></i>
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#categories" className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors duration-300 cursor-pointer">
          <span className="text-xs font-medium">Scroll to explore</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}